export default{
  'planned': 'Planejado',
  'development': 'Desenvolvimento',
  'staging': 'Homologação',
  'production': 'Produção',
  options: [
    { value: 'planned', text: 'Planejado' },
    { value: 'development', text: 'Desenvolvimento' },
    { value: 'staging', text: 'Homologação' },
    { value: 'production', text: 'Produção' },
  ],
}
